export enum EOptionCategory {
  OC_Gameplay,
  OC_Audio,
  OC_Video,
  OC_Controls,
  OC_Keybindings,
  OC_UserInterface,
  OC_Online,
  OC_Debug,
}

export const EOptionCategoryDisplayName = {
  [EOptionCategory.OC_Gameplay]: 'Gameplay',
  [EOptionCategory.OC_Audio]: 'Audio',
  [EOptionCategory.OC_Video]: 'Video',
  [EOptionCategory.OC_Controls]: 'Controls',
  [EOptionCategory.OC_Keybindings]: 'Keybindings',
  [EOptionCategory.OC_UserInterface]: 'User Interface',
  [EOptionCategory.OC_Online]: 'Online',
  [EOptionCategory.OC_Debug]: 'Debug',
};
